// Only symbolic destinations are accepted. Never redirect to a caller-supplied URL.
const key = 'hogcloud-account-continuation';
const lifetime = 30 * 60 * 1000;
export const captureContinuation = (search: string) => {
  const query = new URLSearchParams(search);
  if (!query.has('continue')) return;
  const destination = query.get('continue');
  const allowed = (destination === 'devicehog' && ['hogcloud.net', 'www.hogcloud.net'].includes(window.location.hostname))
    || (destination === 'devicehog-local' && ['localhost', 'hogcloud.net', 'www.hogcloud.net'].includes(window.location.hostname));
  if (allowed) sessionStorage.setItem(key, JSON.stringify({ destination, created: Date.now() }));
  else sessionStorage.removeItem(key);
};
export const accountContinuation = (): string | null => {
  try {
    const value = JSON.parse(sessionStorage.getItem(key) || 'null');
    if (!value || typeof value.created !== 'number' || value.created > Date.now() || Date.now() - value.created > lifetime) {
      sessionStorage.removeItem(key);
      return null;
    }
    if (value.destination === 'devicehog' && ['hogcloud.net', 'www.hogcloud.net'].includes(window.location.hostname)) return 'https://devicehog.com/auth/start';
    if (value.destination === 'devicehog-local' && ['localhost', 'hogcloud.net', 'www.hogcloud.net'].includes(window.location.hostname)) return 'http://localhost:5173/auth/start';
  } catch { /* Ignore invalid continuation storage. */ }
  return null;
};
export const continueToAccountSite = () => {
  const destination = accountContinuation();
  if (!destination) return false;
  sessionStorage.removeItem(key);
  window.location.assign(destination);
  return true;
};
